<template>
  <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption }} -->
  <Video
    v-if="type?.startsWith('video')"
    :url="url"
    :type="type"
    :alt="$t('preview')"
  />
  <img
    v-else-if="type?.startsWith('image')"
    :src="url"
    :alt="$t('preview')"
    class="w-full h-full object-cover rounded-4"
  >
  <div v-else class="other">
    <div class="other-label">
      {{ type }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import Video from './Video.vue';

interface Props {
  url: string;
  type?: string;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
.other {
  @apply bg-white w-full h-full flex justify-center items-center;
  @apply border border-element-neutral rounded-4;
  @apply py-5 px-3 bg-background-light;
}
</style>
